var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Paper from '../../components/Paper';
var CardPaper = styled(Paper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  &.inverted-card {\n    background: ", ";\n  }\n"], ["\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  &.inverted-card {\n    background: ", ";\n  }\n"])), function (props) { return props.theme.colors.black.default; });
export { CardPaper };
var templateObject_1;
//# sourceMappingURL=styles.js.map